import * as React from "react";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { PensionOption } from "../../../../../Wrap/Constants/Enums/Apply/PensionOption";
import { InstructionStatus } from "../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { StepType } from "../../../../Shared/Process/Process/Process";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Action } from "../../../Actions/Action";
import { Contents } from "../../../Resoures/Contents";
import { ProductDetailsStore } from "../../../Stroes/Variable";
import { Urls } from "../../../Urls";
import { DrawdownCalculationStoreStore } from "../Common/SIPP/DrawdownDetails/Store/Variable";
import { PensionBenefitsAction } from "./Actions/PensionBenefitsAction";
import { IncomePaymentDetails } from "./Components/IncomePaymentDetails/IncomePaymentDetails";
import { PensionBenefitsDetails } from "./Components/PensionBenefitsDetails/PensionBenefitsDetails";
import { Review } from "./Components/Review/Review";
import { productMap, PensionBenefitsSteppersMap } from "./Resource/Contents";
import { PensionBenefitsInstructionStore } from "./Store/Variable";

interface IPensionBenefitsWizardState extends IAccountContextWizardComponentState {}
export class PensionBenefitsWizard extends AccountContextWizardComponent<IPensionBenefitsWizardState> {
    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            customer: null,
            clientAccount: null,
        };
    }

    constructor(props: any) {
        super(props);
        this.subscribeToStore(PensionBenefitsInstructionStore, () => this.onInstructionStoreChange());
        this.subscribeToStore(DrawdownCalculationStoreStore, () => this.onPostDrawdown());
    }

    private onInstructionStoreChange() {
        if (PensionBenefitsInstructionStore.getActionType() == ActionType.Success) {
            const data = PensionBenefitsInstructionStore.getData();
            this.setState({
                isLoading: false,
                data: data,
                onPosting: false,
                active: data?.Status === InstructionStatus.Pending || data?.Status === InstructionStatus.NotSpecified,
            });
        }
    }

    private onPostDrawdown() {
        if (DrawdownCalculationStoreStore.getActionType() == ActionType.Loading) {
            this.setState({ onPosting: true });
        }
    }

    componentDidMount() {
        super.componentDidMount();
        const hierarchyId = getQueryParameters()["hierarchyid"];
        this.getProductDetails(hierarchyId);
    }

    componentDidUpdate(prevProps) {
        const { customer, clientAccount } = this.state;
        if (clientAccount && customer && !this.state.data) {
            const id = getQueryParameters()["id"];
            const type = Number(getQueryParameters()["type"]);

            const npr = clientAccount.SubAccounts.find((x) => x.SubAccountType == SubAccountType.Npr);
            if (npr) {
                PensionBenefitsAction.getInstruction(
                    id,
                    type,
                    clientAccount.HierarchyId,
                    npr.HierarchyId,
                    customer.CustomerId
                );
            }
        }
    }

    private getProductDetails(hierarchyId: string) {
        const _date = JsonDateParser.getFormatDateString(new Date(), "yyyy/MM/dd") as any;
        const wrapcash = ProductDetailsStore.getSubAccount(SubAccountType.WrapCash);

        if (!wrapcash) {
            Action.getProductsValuationDetailSummary(hierarchyId, null, _date);
        }
    }

    saveInstruction(from, to, toUrl, params) {
        if (!params["id"]) {params["id"] = this.state.data.HierarchyId;}
        const { customer } = this.state;
        PensionBenefitsAction.saveInstruction(from, this.state.data, customer?.CustomerId, (result) => {
            this.setState({ onPosting: false });
            if (result?.length > 0) {
                this.setState({
                    errorMsg: result,
                    isShowErrorMsg: true,
                });
            } else {
                if (to == -1) {
                    this.onExit();
                } else {
                    Navigator.navigateTo(toUrl, {
                        queryParamsObject: params,
                        scrollAfterNavigating: true,
                    });
                }
            }
        });
    }

    onCancel() {
        // PensionBenefitsAction.deleteInstruction(this.state.data.HierarchyId, () => this.onExit());
        //SLP-70599
        this.onExit();
    }

    onExit() {
        const params = getQueryParameters();
        //TODO: navigate to customer dashboard
        // Navigator.navigateTo(Urls.get().main.ClientDashboard, {
        //     queryParamsObject: {
        //         hierarchyid: params["hierarchyid"],
        //     },
        //     scrollAfterNavigating: true,
        // });
    }

    onSubmit() {
        this.setState({ isSubmitting: true, active: false, isShowErrorMsg: false, errorMsg: [] });
        PensionBenefitsAction.submitInstruction(
            this.state.data.HierarchyId,
            this.state.data.Contribution,
            this.state.data.ClientDetails.ActorId,
            this.state.data.SubAccountClientDetail.ClAccountId,
            () => this.setState({ isSubmitting: false })
        );
    }

    getStepProps(index) {
        const { active } = this.state;
        const stepProps = super.getStepProps(index);
        stepProps.isReview = !active;
        return stepProps;
    }

    private setReviewConfirmSteppers() {
        const type = Number(getQueryParameters()["type"]);
        const clAccountId = getQueryParameters()["claccountid"];
        const len = this.stepperConfig.length;
        const { data } = this.state;
        return [
            {
                title: PensionBenefitsSteppersMap.review,
                url: Urls.get().PensionBenefitsReview,
                path: Contents.URLMap.review,
                onSubmit: () => this.onSubmit(),
                canSubmit: () => this.child[this.stepperConfig.length - 2].isValid(),
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: <Review {...this.getStepProps(len)} type={type} />,
            },
            {
                title: PensionBenefitsSteppersMap.comfirm,
                url: Urls.get().PensionBenefitsConfiramation,
                path: Contents.URLMap.confirmation,
                type: StepType.Confirmation,
                component: (
                    <Confirmation
                        onExit={() => this.onExit()}
                        successMessage={`We've' received your instruction to set up Take pension benefits for ${data?.ClientDetails?.FirstName} ${data?.ClientDetails?.LastName}`}
                        isLoading={this.state.isSubmitting}
                        accountNumberMessage={`(${clAccountId})`}
                    />
                ),
            },
        ];
    }

    setStepperConfig() {
        const type = Number(getQueryParameters()["type"]);
        const { customer } = this.state;
        const steppers = [
            {
                title: PensionBenefitsSteppersMap.pensionBenefitsDetails,
                url: Urls.get().PensionBenefitsDetails,
                path: Contents.URLMap.pensionBenefitsDetails,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <PensionBenefitsDetails {...this.getStepProps(0)} type={type} customerId={customer?.CustomerId} />
                ),
            },
        ];
        if (
            this.state.data?.Contribution?.DrawdownModel?.PensionOption == PensionOption.Drawdown &&
            this.state.data?.Contribution?.DrawdownModel?.ImmediateTaxFreeCashRequestId == null
        ) {
            steppers.push({
                title: PensionBenefitsSteppersMap.incomePaymentDetails,
                url: Urls.get().PensionBenefitsIncomePaymentDetails,
                path: Contents.URLMap.incomePayment,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: <IncomePaymentDetails {...this.getStepProps(1)} type={type} />,
            });
        }
        this.stepperConfig = steppers;
        this.stepperConfig = this.stepperConfig.concat(this.setReviewConfirmSteppers());
    }

    setProcessProps() {
        const type = Number(getQueryParameters()["type"]);
        const processProps = super.setProcessProps();
        processProps.processTitle = "Take pension benefits";
        processProps.subTitle = productMap[type];
        return processProps;
    }
}
